import { BidLimitBalance, FetchBidLimitParams } from './bidLimit.types';
import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { getAuthToken, getBidderId, isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { getBidLimitBalance } from './bidLimit.api';
import { getDeployment } from '@/redux/modules/config';
import { shouldFetchBidLimit } from './bidLimit.selectors';

export const fetchBidLimitBalance = createAsyncThunk<BidLimitBalance, Omit<FetchBidLimitParams, 'force'>>(
    'la/ui/bidLimit/fetchBidLimitBalance',
    async ({ catalogId, itemId }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const bidderId = getBidderId(state);
        const deployment = getDeployment(state);

        const { payload } = await getBidLimitBalance({ authToken, bidderId, catalogId, deployment, itemId });
        return payload;
    }
);

export const fetchBidLimitBalanceIfNeeded = createAsyncThunk<void, FetchBidLimitParams>(
    'la/ui/bidLimit/fetchBidLimitBalanceIfNeeded',
    async ({ catalogId, force = false, itemId }, { dispatch, getState }) => {
        const state = getState();
        const loggedIn = isUserLoggedIn(state);

        if ((force || shouldFetchBidLimit(state, catalogId)) && loggedIn) {
            await dispatch(fetchBidLimitBalance({ catalogId, itemId }));
        }
    }
);
